<template>
    <v-card flat min-height="273">
        <v-container align-start fill-height>
            <v-layout align-center row wrap>
                <v-flex pt-0 xs12>
                    <h4 class="subheading text-xs-left font-weight-regular section-title--color">
                        Facebook
                    </h4>
                </v-flex>
                <v-flex md6 sm12 xs12>
                    <FacebookInfoTile
                            :count="totalNumFacebookPosts"
                            title="Facebook Page Post"
                            v-if="fetchReady"
                    />
                    <div class="text-xs-center" v-else>
                        <v-progress-circular
                                color="bindezcolor"
                                indeterminate
                        ></v-progress-circular>
                    </div>
                </v-flex>
                <v-flex md6 sm12 style="height:85px;" xs12></v-flex>
                <v-flex md6 sm12 xs12>
                    <FacebookInfoTile
                            :count="totalNumFacebookPages"
                            title="Facebook Pages"
                            v-if="fetchReady"
                    />
                    <div class="text-xs-center" v-else>
                        <v-progress-circular
                                color="bindezcolor"
                                indeterminate
                        ></v-progress-circular>
                    </div>
                </v-flex>
                <v-flex md6 sm12 xs12>
                    <FacebookInfoTile
                            :count="totalNumKeywordsFound"
                            title="Keywords Found"
                            v-if="summaryReady && mentionPageReady"

                    />
                    <div class="text-xs-center" v-else>
                        <v-progress-circular
                                color="bindezcolor"
                                indeterminate
                        ></v-progress-circular>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
	import FacebookInfoTile from "./FacebookInfoTile";
	import {mapState} from 'vuex';

	export default {
		name: "FacebookInfo",
		components: {
			FacebookInfoTile
		},
		computed: {
			...mapState([
				'facebookSummary',

			]),

			...mapState('mention', [
				'mentionPageReady',
				'summaryReady'
			]),

			fetchReady() {
				return this.mentionPageReady && this.summaryReady;
			},

			totalNumFacebookPosts() {
				return this.facebookSummary.fbposts.numFound;
			},

			totalNumFacebookPages() {
				return (this.facebookSummary.fbposts.page_id.length) / 2;
			},

			totalNumKeywordsFound() {
				return Object.entries(this.facebookSummary.facebook_mentions_by_keywords).filter(keyword => !!keyword[1]).length
			}
		}
	}
</script>

<style scoped>
    h3 {
        display: inline-block;
    }
</style>
